export default __webpack_public_path__ + "static/helmet_product_bike-b8b93e63b083f0a9d5748c5797abbb88.png";